// extracted by mini-css-extract-plugin
export default {"headerContent":"style_headerContent__l9CuH","headerRight":"style_headerRight__TCgON"};